import {gql, useLazyQuery} from '@apollo/client';
import {useEffect, useMemo} from "react";

export const useQuerySdqlData = (queryString: string, sport: string, skip: boolean = false) => {
    const [executeQuery, {called, loading, data, error}] = useLazyQuery(QUERY_SDQL_DATA, {
        variables: {queryString: queryString},
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        if (queryString) {
            if(!skip) {
                executeQuery({
                    variables: {queryString, sport},
                });
            }

        }
    }, [queryString, executeQuery, sport, skip]);

    return {data, loading, error};
};

const QUERY_SDQL_DATA = gql`
    query SdqlQuery($queryString: String, $sport: String) {
      sdqlQuery(queryString: $queryString, sport: $sport) {
        points
        oPoints
        date
        startTime
        line
        oLine
        total
        ouMargin
        atsMargin
        assists
        oAssists
        team
        oTeam
        dynamicFields
      }
    }
`;

const QUERY_SDQL_SUMMARY_DATA = gql`
    query SdqlSummaryQuery(
        $queryString: String, 
        $addedFields: [String], 
        $sport: String
    ) {
      sdqlSummaryQuery(queryString: $queryString, addedFields: $addedFields, sport: $sport) {
        avgPoints
        avgOPoints
        avgStartTime
        avgLine
        avgOLine
        avgTotal
        avgOuMargin
        avgAtsMargin
        wins
        losses
        overs
        unders
        atsWins
        atsLosses
        dynamicFields
      }
    }
`;

const stringIsSummativeField = (str: string) => str.includes('tS(') || str.includes('S(') || str.includes('tA(') || str.includes('A(')

export const useQuerySdqlSummaryData = (queryString: string, sport: string, skip: boolean = false) => {
    const hasAtClause = queryString.includes('@');
    const splitQueryString = queryString.split('@');
    const addedFields = useMemo(() => {
        if (!hasAtClause) return [];
        return queryString.split('@')[0].split(',')
            .map((el: string) => el.trim())
            .filter((el: string) => el && stringIsSummativeField(el));
    }, [queryString, hasAtClause]);


    const summativeFields = hasAtClause ? splitQueryString?.[0]
        .split(',')?.filter((field: string) =>
            stringIsSummativeField(field)
        )?.join(',') : undefined;
    const useSummativeFields = hasAtClause && summativeFields
    const queryStringToUse = useSummativeFields ? `${summativeFields}@${splitQueryString[1]}` : queryString
    const [executeQuery, {called, loading, data, error}] = useLazyQuery(QUERY_SDQL_SUMMARY_DATA, {
        variables: {queryString: queryStringToUse, addedFields, sport},
        fetchPolicy: "no-cache"
    });

    useEffect(() => {
        if (!skip && queryString && addedFields) {
            executeQuery({variables: {queryString: queryStringToUse, addedFields, sport}});
        }
        if (!skip && queryString && !addedFields) {
            executeQuery({variables: {queryString: queryStringToUse, sport}});
        }
    }, [
        queryString,
        executeQuery,
        addedFields,
        queryStringToUse,
        sport
    ]);

    return {data, loading, error};
};
